"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2107],{

/***/ 40026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jc": function() { return /* binding */ AssetWithdrawalContext; },
  "b2": function() { return /* binding */ AssetWithdrawalProvider; }
});

// UNUSED EXPORTS: initValue

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@orca-so/common-sdk/dist/index.js
var dist = __webpack_require__(66259);
// EXTERNAL MODULE: ./node_modules/@solana/spl-token/lib/index.browser.esm.js + 5 modules
var index_browser_esm = __webpack_require__(974);
// EXTERNAL MODULE: ./node_modules/@solana/web3.js/lib/index.browser.esm.js + 3 modules
var lib_index_browser_esm = __webpack_require__(27632);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/use-balances.ts
var use_balances = __webpack_require__(68203);
// EXTERNAL MODULE: ./src/hooks/use-deposit-token-options.ts
var use_deposit_token_options = __webpack_require__(74733);
// EXTERNAL MODULE: ./src/hooks/use-nemo-wallet.ts
var use_nemo_wallet = __webpack_require__(6200);
// EXTERNAL MODULE: ./src/hooks/use-safely-send-tx-with-notice.tsx + 1 modules
var use_safely_send_tx_with_notice = __webpack_require__(76243);
// EXTERNAL MODULE: ./node_modules/decimal.js/decimal.mjs
var decimal = __webpack_require__(90482);
// EXTERNAL MODULE: ./src/utils/numeric.ts
var numeric = __webpack_require__(14847);
;// CONCATENATED MODULE: ./src/utils/cypress-support/utils.ts




const utils_parseFloat = (value)=>toDecimal(value).toNumber();
const toFixed = (param)=>{
    let { value , decimals , rounding  } = param;
    return format(value, {
        decimals,
        rounding
    });
};
const toU64 = function(number) {
    let decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return dist.DecimalUtil.toU64(new decimal/* default */.Z(number).toDP(decimals), decimals);
};
const formatError = (err)=>"> ".concat(err.message, "\n\n").concat(err.logs && err.logs.length ? "Transaction logs:\n- ".concat(err.logs.join("\n- "), "\n\n") : "", "Stack trace:\n").concat(err.stack);
/**
 * Wraps a task function to be called from `cy.retryableTask`.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const retryable = (fn)=>{
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        try {
            const result = fn(...args);
            return result instanceof Promise ? result.then((result)=>({
                    retry: false,
                    result
                }), (reason)=>({
                    retry: true,
                    error: formatError(reason)
                })) : {
                retry: false,
                result
            };
        } catch (error) {
            return {
                retry: true,
                error: formatError(error)
            };
        }
    };
};
/**
 * Recomposes the list of tasks by turning some into {@link retryable}s and
 * attach {@link healer}s to all.
 */ const buildTasksObject = (param)=>{
    let { tasks , retryables =[] , pills =[]  } = param;
    const withHealer = healer(...pills);
    return Object.fromEntries(Object.entries(tasks).map((param)=>{
        let [task, fn] = param;
        return [
            task,
            retryables.includes(task) ? retryable(withHealer(fn)) : withHealer(fn)
        ];
    }));
};

// EXTERNAL MODULE: ./src/wallet/adapter.ts + 1 modules
var adapter = __webpack_require__(33618);
;// CONCATENATED MODULE: ./src/components/base/AssetWithdrawal/utils.ts
const NETWORK_RENEC = "RENEC Network";
const renecNetworkOption = {
    chain_name: NETWORK_RENEC,
    chain_name_abbr: NETWORK_RENEC
};
// to be fetched from API in the future
// Note: RENEC should be first of the list
const networkOptions = [
    renecNetworkOption
];

;// CONCATENATED MODULE: ./src/components/base/AssetWithdrawal/context.tsx












const initValue = {
    selectedToken: null,
    setSelectedToken: ()=>null,
    submitWithdrawByRenecNetwork: ()=>Promise.resolve(),
    currentTokenBalance: 0,
    isSubmitSucceeded: false,
    setIsSubmitSucceeded: ()=>null,
    isLoading: false,
    tokenOptions: [],
    networkOptions: []
};
const AssetWithdrawalContext = /*#__PURE__*/ (0,react.createContext)(initValue);
const AssetWithdrawalProvider = (param)=>{
    let { children  } = param;
    const { balances  } = (0,use_balances/* useBalances */.l)();
    const { connection  } = (0,adapter/* useConnection */.Rc)();
    const { anchorWallet , publicKey: senderWalletPubkey  } = (0,use_nemo_wallet/* default */.Z)();
    const { safelySendTxWithNotice  } = (0,use_safely_send_tx_with_notice/* default */.Z)("make_asset_withdrawal");
    const { tokenOptions , isLoading: isLoadingTokenOptions  } = (0,use_deposit_token_options/* default */.Z)();
    const [selectedToken, setSelectedToken] = (0,react.useState)(null);
    const [isSubmitting, setIsSubmitting] = (0,react.useState)(false);
    const [isSubmitSucceeded, setIsSubmitSucceeded] = (0,react.useState)(false);
    const isLoading = isLoadingTokenOptions || isSubmitting;
    const currentTokenBalance = (0,react.useMemo)(()=>{
        const tokenSymbol = selectedToken === null || selectedToken === void 0 ? void 0 : selectedToken.symbol;
        if (!tokenSymbol) {
            return 0;
        }
        return (balances === null || balances === void 0 ? void 0 : balances[tokenSymbol]) || 0;
    }, [
        balances,
        selectedToken
    ]);
    (0,react.useEffect)(()=>{
        if (!selectedToken) {
            setIsSubmitting(false);
            setIsSubmitSucceeded(false);
        }
    }, [
        selectedToken
    ]);
    const submitWithdrawByRenecNetwork = (0,react.useCallback)(async (toWalletAddress, tokenAmount)=>{
        if (isSubmitting) return;
        setIsSubmitting(true);
        if (!selectedToken) {
            throw Error("[assets:withdraw] no token info");
        }
        if (!senderWalletPubkey || !toWalletAddress) {
            throw Error("[assets:withdraw] missing wallet addresses");
        }
        if (!tokenAmount) {
            throw Error("[assets:withdraw] input amount");
        }
        const tokenMintPubkey = new lib_index_browser_esm.PublicKey(selectedToken.address);
        const fromWallet = senderWalletPubkey;
        const toWallet = new lib_index_browser_esm.PublicKey(toWalletAddress);
        const txBuilder = new dist.TransactionBuilder(connection, anchorWallet);
        if (tokenMintPubkey.equals(index_browser_esm.NATIVE_MINT)) {
            txBuilder.addInstruction({
                cleanupInstructions: [],
                instructions: [
                    lib_index_browser_esm.SystemProgram.transfer({
                        fromPubkey: fromWallet,
                        toPubkey: toWallet,
                        lamports: toU64(tokenAmount, selectedToken.decimals).toNumber()
                    })
                ],
                signers: []
            });
        } else {
            const senderATA = await index_browser_esm.Token.getAssociatedTokenAddress(index_browser_esm.ASSOCIATED_TOKEN_PROGRAM_ID, index_browser_esm.TOKEN_PROGRAM_ID, tokenMintPubkey, fromWallet);
            const receiverATA = await index_browser_esm.Token.getAssociatedTokenAddress(index_browser_esm.ASSOCIATED_TOKEN_PROGRAM_ID, index_browser_esm.TOKEN_PROGRAM_ID, tokenMintPubkey, toWallet, true);
            // Initialize receiverATA if not yet created.
            const receiverATAInfo = await connection.getAccountInfo(receiverATA);
            if (!receiverATAInfo) {
                txBuilder.addInstruction({
                    cleanupInstructions: [],
                    instructions: [
                        index_browser_esm.Token.createAssociatedTokenAccountInstruction(index_browser_esm.ASSOCIATED_TOKEN_PROGRAM_ID, index_browser_esm.TOKEN_PROGRAM_ID, tokenMintPubkey, receiverATA, toWallet, fromWallet)
                    ],
                    signers: []
                });
            }
            txBuilder.addInstruction({
                cleanupInstructions: [],
                instructions: [
                    index_browser_esm.Token.createTransferInstruction(index_browser_esm.TOKEN_PROGRAM_ID, senderATA, receiverATA, fromWallet, [], toU64(tokenAmount, selectedToken.decimals).toNumber())
                ],
                signers: []
            });
        }
        const txid = await safelySendTxWithNotice(txBuilder);
        if (txid) {
            setIsSubmitSucceeded(true);
        }
        setIsSubmitting(false);
    }, [
        selectedToken,
        anchorWallet,
        connection,
        isSubmitting,
        senderWalletPubkey,
        safelySendTxWithNotice
    ]);
    const ctxValue = (0,react.useMemo)(()=>({
            selectedToken,
            setSelectedToken,
            currentTokenBalance,
            submitWithdrawByRenecNetwork,
            isLoading,
            isSubmitSucceeded,
            setIsSubmitSucceeded,
            tokenOptions,
            networkOptions: networkOptions
        }), [
        selectedToken,
        setSelectedToken,
        currentTokenBalance,
        submitWithdrawByRenecNetwork,
        isLoading,
        isSubmitSucceeded,
        setIsSubmitSucceeded,
        tokenOptions
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AssetWithdrawalContext.Provider, {
        value: ctxValue,
        children: children
    });
};


/***/ }),

/***/ 57606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ container; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Clear.js
var Clear = __webpack_require__(63343);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/base/Button/index.tsx
var Button = __webpack_require__(10737);
// EXTERNAL MODULE: ./src/hooks/useTrans.ts + 1 modules
var useTrans = __webpack_require__(39838);
;// CONCATENATED MODULE: ./src/components/common/ModalLayout/container.tsx






const Container = (param)=>{
    let { children , title , onClose , isDisplayBtnClose , footer , isInsideDrawer , customWidthClasses  } = param;
    const trans = (0,useTrans/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        className: classnames_default()("bg-[#1E2735] iw:bg-white text-white iw:text-[#000E0F] rounded-[16px]", {
            "rounded-b-none": isInsideDrawer,
            ["".concat(customWidthClasses || "w-[343px] sm:w-[484px]", " max-h-[90vh] overflow-auto absolute top-1/2	left-1/2 translate-x-[-50%] translate-y-[-50%]")]: !isInsideDrawer
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: "px-6 py-[11px] bg-[#1A2330] iw:bg-[#F6FBFF] rounded-t-[16px]",
                display: "flex",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-xl font-bold",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Clear/* default */.Z, {
                        className: "cursor-pointer",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: "p-6",
                children: [
                    children,
                    isDisplayBtnClose && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onClose,
                        "data-testid": "btn-close",
                        className: "mt-[12px]",
                        fullWidth: true,
                        variant: "outlined",
                        size: "xl",
                        children: trans.wrapped_token.btn_close
                    }),
                    footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-center text-xs text-gray-500 mt-2 relative top-2",
                        children: footer
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var container = (Container);

;// CONCATENATED MODULE: ./src/components/common/ModalLayout/index.ts



/***/ }),

/***/ 63811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ METHOD_TYPE; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_Clear__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63343);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99226);
/* harmony import */ var _mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6514);
/* harmony import */ var _mui_material_Drawer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(58826);
/* harmony import */ var _mui_material_Modal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80437);
/* harmony import */ var _mui_material_Stack__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26447);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98396);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39838);













const METHOD_TYPE = {
    network: "network",
    bank: "bank",
    swapOthers: "swapOthers"
};
const classesDialog = {
    root: "outline-none p-0 h-full"
};
const MethodSelectionDialog = (param)=>{
    let { onClose , onClick , selectedDepositToken , selectedWithdrawToken , isP2pSupported  } = param;
    const trans = (0,_hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const isDesktop = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(theme.breakpoints.up("sm"));
    const isOpenDialog = Boolean(selectedDepositToken || selectedWithdrawToken);
    const tokenSymbol = (selectedDepositToken === null || selectedDepositToken === void 0 ? void 0 : selectedDepositToken.symbol) || (selectedWithdrawToken === null || selectedWithdrawToken === void 0 ? void 0 : selectedWithdrawToken.symbol);
    const tokenDisplaySymbol = (selectedDepositToken === null || selectedDepositToken === void 0 ? void 0 : selectedDepositToken.displaySymbol) || (selectedWithdrawToken === null || selectedWithdrawToken === void 0 ? void 0 : selectedWithdrawToken.displaySymbol);
    const methodOptions = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (!tokenSymbol) return [];
        const isSupportMethod = isP2pSupported(tokenSymbol);
        return selectedWithdrawToken ? [
            {
                title: trans.core_tokens_list.network.withdraw,
                description: trans.core_tokens_list.network.description,
                type: METHOD_TYPE.network,
                dataTestID: "method-selection-network",
                icon: "/assets-to-others-icon.png"
            }
        ] : [
            {
                title: isSupportMethod ? trans.core_tokens_list.bank.deposit : trans.core_tokens_list.others.deposit(tokenSymbol),
                description: isSupportMethod ? trans.core_tokens_list.bank.description : trans.core_tokens_list.others.description(tokenSymbol, false),
                type: METHOD_TYPE.bank,
                dataTestID: "method-selection-bank",
                icon: isSupportMethod ? "/assets-from-bank-icon.png" : "/assets-swap-icon.png"
            },
            {
                title: trans.core_tokens_list.network.deposit,
                description: trans.core_tokens_list.network.description,
                type: METHOD_TYPE.network,
                dataTestID: "method-selection-network",
                icon: "/assets-from-others-icon.png"
            }
        ];
    }, [
        tokenSymbol,
        selectedWithdrawToken,
        trans,
        isP2pSupported
    ]);
    const renderedContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: "bg-[#1E2735] text-white rounded-[16px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                display: "flex",
                justifyContent: "space-between",
                className: "px-6 py-[11px] bg-[#1A2330] rounded-t-[16px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        className: "text-base font-bold",
                        children: [
                            selectedDepositToken ? trans.common.deposit : trans.common.withdraw,
                            " ",
                            tokenDisplaySymbol
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Clear__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        className: "cursor-pointer",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "px-4 py-6",
                gap: "8px",
                children: methodOptions.map((method)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        gap: "8px",
                        direction: "row",
                        alignItems: "center",
                        className: "bg-[#141A23] py-5 px-4 rounded-lg cursor-pointer",
                        onClick: ()=>onClick(method.type),
                        "data-testid": method.dataTestID,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                alt: method.title,
                                src: method.icon,
                                className: "object-cover",
                                width: 40,
                                height: 40
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        className: "text-base font-semibold",
                                        children: method.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        className: "text-[#9CA3AE] text-sm",
                                        children: method.description
                                    })
                                ]
                            })
                        ]
                    }, method.type))
            })
        ]
    });
    if (isDesktop) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            open: isOpenDialog,
            onClose: onClose,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                classes: classesDialog,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: "w-[343px] sm:w-[484px] max-h-[90vh] overflow-auto absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%]",
                    children: renderedContent
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Drawer__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
        open: isOpenDialog,
        onClose: onClose,
        anchor: "bottom",
        sx: {
            ".MuiPaper-elevation": {
                backgroundColor: "transparent",
                backgroundImage: "none"
            }
        },
        children: renderedContent
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(MethodSelectionDialog));


/***/ }),

/***/ 65932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_base_AssetWithdrawal_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40026);
/* harmony import */ var _components_base_WrappedTokensFlow_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96661);
/* harmony import */ var _components_core_tokens_list_MethodSelectionDialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63811);
/* harmony import */ var _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28309);







const useAssetsMethodSelectionFlow = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { fiatTokensList  } = (0,_hooks_use_tokens__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Co)();
    const { setSelectedToken: setWithdrawToken  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_components_base_AssetWithdrawal_context__WEBPACK_IMPORTED_MODULE_3__/* .AssetWithdrawalContext */ .jc);
    const { setSelectedToken: setDepositToken  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_components_base_WrappedTokensFlow_context__WEBPACK_IMPORTED_MODULE_4__/* .WrappedTokensFlowContext */ .H$);
    const [selectedDepositToken, setSelectedDepositToken] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const [selectedWithdrawToken, setSelectedWithdrawToken] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const isP2pSupported = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((tokenSymbol)=>fiatTokensList.some((fiatToken)=>tokenSymbol === fiatToken.symbol), [
        fiatTokensList
    ]);
    const openDepositModal = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((token)=>{
        setSelectedDepositToken(token);
    }, [
        setSelectedDepositToken
    ]);
    const openWithdrawModal = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((token)=>{
        setSelectedWithdrawToken(token);
    }, [
        setSelectedWithdrawToken
    ]);
    const closeMethodSelectionDialog = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        setSelectedDepositToken(null);
        setSelectedWithdrawToken(null);
    }, []);
    const onClickMethod = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((type)=>{
        if (type === _components_core_tokens_list_MethodSelectionDialog__WEBPACK_IMPORTED_MODULE_5__/* .METHOD_TYPE.network */ .z.network) {
            selectedDepositToken && setDepositToken(selectedDepositToken);
            selectedWithdrawToken && setWithdrawToken(selectedWithdrawToken);
        }
        if (type === _components_core_tokens_list_MethodSelectionDialog__WEBPACK_IMPORTED_MODULE_5__/* .METHOD_TYPE.bank */ .z.bank) {
            selectedDepositToken && (isP2pSupported(selectedDepositToken.symbol) ? router.push("/buy/".concat(selectedDepositToken.symbol)) : router.push("/reVND_".concat(selectedDepositToken.symbol)));
            selectedWithdrawToken && (isP2pSupported(selectedWithdrawToken.symbol) ? router.push("/sell/".concat(selectedWithdrawToken.symbol)) : router.push("/".concat(selectedWithdrawToken.symbol, "_reVND")));
        }
        closeMethodSelectionDialog();
    }, [
        router,
        selectedDepositToken,
        selectedWithdrawToken,
        setDepositToken,
        setWithdrawToken,
        closeMethodSelectionDialog,
        isP2pSupported
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        return {
            openDepositModal,
            openWithdrawModal,
            setSelectedDepositToken,
            setSelectedWithdrawToken,
            rendered: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_tokens_list_MethodSelectionDialog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                onClose: closeMethodSelectionDialog,
                selectedDepositToken: selectedDepositToken,
                selectedWithdrawToken: selectedWithdrawToken,
                onClick: onClickMethod,
                isP2pSupported: isP2pSupported
            })
        };
    }, [
        closeMethodSelectionDialog,
        isP2pSupported,
        onClickMethod,
        openDepositModal,
        openWithdrawModal,
        selectedDepositToken,
        selectedWithdrawToken
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useAssetsMethodSelectionFlow);


/***/ })

}]);